import {  CircleCheck } from "lucide-react";
import ReactDOMServer from 'react-dom/server';
import Swal, { SweetAlertOptions } from "sweetalert2";
//import logo from "../assets/img/logo-en-blanco.png";

export const CustomToast = ({ status, msg, title }: any) => {
  console.log(msg);

  switch (status) {
    case 200:
      {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "custom-toast",
            title: "custom-toast-title",
            timerProgressBar: "custom-toast-progress",
            icon: "custom-toast-icon"
          },
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);
        Toast.fire({
          //iconHtml: `<img src="${logo}" class="" style="" />`, // Ícono personalizado
          icon: "success",
          title: title,
        });
      }
      break;
    case 400:
      {
        const Toast = Swal.mixin({
          toast: true,
          position: "bottom",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "custom-toast",
            title: "custom-toast-title",
            timerProgressBar: "custom-toast-progress",
            icon: "custom-toast-icon"
          },
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);
        Toast.fire({
          icon: "warning",
          title: title,
        });
      }
      break;
    case "success": {
      const iconHtml = ReactDOMServer.renderToString(<CircleCheck size={70} color="#4CAF50" />);

      const option: SweetAlertOptions = {
        iconHtml: iconHtml,
        title: `<strong>${title}</strong>`,
        html: `<p>${msg}</p>`,
        showCloseButton: true,
        showConfirmButton: false, // no queremos botón "OK"
        customClass: {
          popup: 'rounded-lg p-4',
          title: 'fw-bold fs-4 text-dark',
          htmlContainer: 'fs-6 text-muted',
          closeButton: 'fs-5',
        },
        width: 400,
        padding: '1rem',
        background: '#fff',
      }
      return Swal.fire(option);
    } break;
    default:
      break;
  }
};
